export const FINANCIAL_SELLER_DATA_FETCH_ERROR =
  'Não conseguimos carregar os dados financeiros :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';
